import React from 'react'
import Websocket from 'react-websocket'
import {WS_URL} from '../../api'
import {Badge, ListGroupItem} from 'reactstrap'
import HistoryIcon from 'react-icons/lib/fa/history'

let ControllerAssignmentListItem = ({controller, teamName, token, handleWebSocketResponse}) => {
    return <ListGroupItem>
        {(controller.online ?
            <Badge color="success" pill>Online</Badge> :
            <Badge color="danger" pill>Offline</Badge>)}
        &emsp;

        <strong>Phone&nbsp;Number:&ensp;</strong>
        {controller.serialNumber}
        &ensp;&mdash;&ensp;

        <strong>Team:&ensp;</strong>
        {teamName && teamName.length ?
            teamName:
            (controller && controller.team && controller.team.name ?
                controller.team.name:
                    "")}
        &emsp;&emsp;

        {(controller.legacyAccess ?
            <Badge color="warning"><HistoryIcon/>&nbsp;Legacy&nbsp;Software</Badge>
            : null)}

        {(token ?
            <Websocket url={`${WS_URL}/controllers/${controller.id}/?access_token=${token.accessToken}`}
                       onMessage={handleWebSocketResponse}/> :
            null)}
    </ListGroupItem>
}

export default ControllerAssignmentListItem



// WEBPACK FOOTER //
// ./src/components/ui/ControllerAssignmentListItem.js